import Home from "views/Home"
import { useRoutes } from "react-router-dom"
import HomeLayout from "layouts/Home"
import About from "views/About"
import WorkDetail from "views/Works/WorkDetail"
import Comment from "views/Works/Comment"
import { Navigate } from "react-router"
import Auth from "views/Auth"
import ContactUs from "views/ContactUs"
import Favorites from "views/Favorites"
import Saves from "views/Saves"
import Vieweds from "views/Vieweds"
import LoginSucces from "./../views/Auth/LoginSucces"
import { useSelector } from "react-redux"

export default () => {
  const { token } = useSelector((state) => state.userDatasReducer)

  const mainRoutes = useRoutes([
    {
      element: <HomeLayout />,
      children: [
        { path: "/", element: <Home /> },
        { path: "/about-us", element: <About /> },
        { path: "/contact-us", element: <ContactUs /> },
        { path: "/auth", element: <Auth /> },
        { path: "/auth/google", element: <LoginSucces /> },
        {
          path: "/favourites",
          element: token ? <Favorites /> : <Navigate to="/auth" />,
        },
        {
          path: "/saves",
          element: token ? <Saves /> : <Navigate to="/auth" />,
        },
        {
          path: "/views",
          element: token ? <Vieweds /> : <Navigate to="/auth" />,
        },
        // {
        //   path: "/works",
        //   element: <Works />,
        // },
        { path: "/works/detail/:id", element: <WorkDetail /> },
        { path: "/works/detail/comments/:id", element: <Comment /> },
        { path: "*", element: <Navigate to="/" /> },
      ],
    },
  ])
  return mainRoutes
}
